module.exports = __webpack_public_path__ + "assets/img/bg-male-41c00826.png";